import Information from './Information'
import Setting from './Setting'

const DomainVNNIC = {
    Information,
    Setting,
}

export default DomainVNNIC
